import { defineMessages } from "react-intl";
const messages = defineMessages({
    save: {
        id: "app.admin.editFeatureAccess.saveButton.text",
        defaultMessage: "Save",
    },
    editFeatureAccess: {
        id: "app.featureAccess.featureAccess.createFeatureAccess.editFeatureAccess.title.text",
        defaultMessage: "Edit feature access",
    },
    editFeatureAccessSuccess: {
        id: "app.admin.editFeatureAccess.editFeatureAccess.success.text",
        defaultMessage: "Feature Access edited successfully.",
    },
    featureAccessType: {
        id: "app.admin.editFeatureAccess.type.text",
        defaultMessage: "Type",
    },
    featureUser: {
        id: "app.admin.editFeatureAccess.user.text",
        defaultMessage: "User",
    },
    featureOrganization: {
        id: "app.admin.editFeatureAccess.organization.text",
        defaultMessage: "Organization",
    },
    featureCommunity: {
        id: "app.admin.editFeatureAccess.community.text",
        defaultMessage: "Community",
    },
    featureAction: {
        id: "app.admin.featureAction.features.text",
        defaultMessage: "Features",
    },
    featureActionRequired: {
        id: "app.admin.addFeature.actionRequired.text",
        defaultMessage: "Features are required",
    },
});
export default messages;
